import http from 'hub-http/clients/apiClient';
import { createRpcClientV2 } from 'rpc-client-utils';
import { startRpc } from '../../../__generated__/chirp/com/hubspot/trello/integration/OAuthRpc';
import { installIntegrationRpc } from '../../../__generated__/chirp/com/hubspot/trello/integration/InstallRpc';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});
export const installTrello = accessToken => {
  return chirpClient.call(installIntegrationRpc, {
    request: {
      accessToken
    }
  });
};
export const startOAuth = () => {
  return chirpClient.call(startRpc, {});
};